const menu = {
  el: document.querySelector('.c-nav--main'),
  oldValue: 0,
  newValue: 0,
};

function scrollDirection() {
  menu.newValue = window.pageYOffset;

  if (menu.oldValue > menu.newValue || menu.newValue < 100) {
    menu.el.style.opacity = 1;
    menu.el.style.zIndex = 1000;
    menu.el.style.transitionDuration = '450ms';
    menu.el.style.top = '0px';
  } else if (menu.oldValue < menu.newValue) {
    menu.el.style.opacity = 0;
    menu.el.style.zIndex = -1000;
    menu.el.style.top = '-86px';
    menu.el.style.transitionDuration = '250ms';
  }
  menu.oldValue = menu.newValue;
}

if (menu.el) {
  window.addEventListener('scroll', () => {
    requestAnimationFrame(scrollDirection);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/menu-anchor.js